import { useContext } from 'react'
import { useMutation } from 'react-query'
import { apiPost } from 'api'
import AuthContext from 'context/auth-context'

const createAiSearch = async (token, dashboardId, params) => {
  const url = `dashboards/${dashboardId}/ai_searches`
  const objectName = 'ai_search'

  const data = await apiPost({ url, token, objectName, params })
  return data
}

export function useAiSearch({ dashboardId, options = {} }) {
  const token = useContext(AuthContext)

  return useMutation(
    ({ query, currentParams }) => {
      return createAiSearch(token, dashboardId, {
        query,
        current_params: currentParams
      })
    },
    { ...options }
  )
}
